import { render, staticRenderFns } from "./AddBooking.vue?vue&type=template&id=46720d3a"
import script from "./AddBooking.vue?vue&type=script&lang=js"
export * from "./AddBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports